import { render, staticRenderFns } from "./SimpleSpaceProduct.vue?vue&type=template&id=7db78a55"
import script from "./SimpleSpaceProduct.vue?vue&type=script&lang=js"
export * from "./SimpleSpaceProduct.vue?vue&type=script&lang=js"
import style0 from "./SimpleSpaceProduct.vue?vue&type=style&index=0&id=7db78a55&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports